import { keyframes, styled } from "@patientmpower/spiro";
import * as PopoverPrimitive from "@radix-ui/react-popover";

const slideUpAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideRightAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(-2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

const slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

const slideLeftAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" },
});

export const PopoverContainer = styled("div", {
  alignSelf: "center",

  "@sm": {
    display: "none",
  },
});

export const StyledContent = styled(PopoverPrimitive.Content, {
  zIndex: 1100,

  marginTop: "4px",
  marginRight: "-32px",

  width: 220,
  borderRadius: 8,

  position: "absolute",
  top: 15,
  right: "1.46%",

  display: "flex",
  flexDirection: "column",

  backgroundColor: "$white",

  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.22)",

  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: "400ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    '&[data-state="open"]': {
      '&[data-side="top"]': { animationName: slideDownAndFade },
      '&[data-side="right"]': { animationName: slideLeftAndFade },
      '&[data-side="bottom"]': { animationName: slideUpAndFade },
      '&[data-side="left"]': { animationName: slideRightAndFade },
    },
  },
});

export const PopoverTrigger = styled(PopoverPrimitive.Trigger, {
  alignSelf: "center",
});

export const IconButton = styled("button", {
  all: "unset",

  borderRadius: "100%",
  height: 36,
  width: 36,

  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  cursor: "pointer",
  color: "$gray-100",
  backgroundColor: "white",

  border: "2px solid transparent",

  "&:hover": {
    border: "2px solid $primary-30",
  },

  "&:focus-visible": {
    outline: "none",

    border: "2px solid $primary-30",
  },

  '&[data-state="open"]': {
    border: "2px solid $primary-30",
  },
});

export const PopoverOption = styled("button", {
  all: "unset",

  height: 56,
  paddingLeft: 15,
  paddingRight: 15,

  fontFamily: "$openSans",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "$text-lg",
  lineHeight: "19px",

  cursor: "pointer",
  color: "$gray-100",
  backgroundColor: "white",

  borderBottom: "1px solid $gray-50",

  "&:hover": {
    backgroundColor: "$gray-30",
  },

  "&:focus-visible": {
    backgroundColor: "$gray-30",
  },

  "&:first-child": {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },

  "&:last-child": {
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",

    borderBottom: "none",
  },
});

export const UserSettingsMobileContainer = styled("button", {
  display: "flex",
  alignItems: "center",

  width: "100%",
  padding: "6px 16px",

  border: "unset",
  borderRadius: "$3",
  backgroundColor: "transparent",

  "&:hover": {
    cursor: "pointer",
    backgroundColor: "$gray-30",
  },

  "&:active": {
    backgroundColor: "$gray-30",
  },

  "&:focus": {
    backgroundColor: "$gray-30",
  },

  img: {
    width: 28,
    height: 28,
  },

  p: {
    paddingLeft: "$6",

    fontFamily: "$openSans",
    fontSize: "$text-xl",
    color: "$gray-90",
  },
});
